import styled from "@emotion/styled";

const Callout = styled.div(({ theme }) => ({
  background: theme.colors.bg,
  borderRadius: theme.borderRadius.lg,
  padding: theme.spacing.lg,
  width: "100%",
  "@media (min-width: 600px)": {
    padding: theme.spacing.xl,
  },
}));

export { Callout };
